import React, { useEffect, useState } from 'react';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import Combobox from '../../Combobox.jsx';
import { CloseIcon } from '../../icons/CloseIcon.jsx';
import CustomSelectMenuItem from '../../CustomSelectMenuItem.jsx';

const IndividualStakeholdersBulkSelect = (props) => {
  const {
    orgStakeholders,
    selectedIndividuals,
    updateSelectedIndividuals,
    isDisabled,
  } = props;

  const [filteredStakeholders, setFilteredStakeholders] = useState(null);

  const isActive = (stakeholder) =>
    selectedIndividuals.includes(stakeholder.id);

  const deleteStakeholder = (stakeholderId) =>
    updateSelectedIndividuals(
      selectedIndividuals.filter((id) => id !== stakeholderId)
    );

  const handleRemove = (stakeholderId) => {
    if (!window.confirm('Are you sure you want to detach this stakeholder?'))
      return;

    deleteStakeholder(stakeholderId);
  };

  const onInputValueChange = (inputValue) =>
    filteredStakeholders.filter(({ fullName }) =>
      fullName.toLowerCase().includes(inputValue.toLowerCase())
    );

  const onSelectedItemChange = (stakeholder) => {
    if (!isActive(stakeholder) && isDisabled(stakeholder.id)) {
      return null;
    }
    selectedIndividuals.includes(stakeholder.id)
      ? deleteStakeholder(stakeholder.id)
      : updateSelectedIndividuals([...selectedIndividuals, stakeholder.id]);
  };

  useEffect(() => {
    setFilteredStakeholders(
      orgStakeholders.filter((item) => item.objectType === 'individual')
    );
  }, [orgStakeholders]);

  return filteredStakeholders ? (
    <FormGroup>
      <ControlLabel>
        Select Individual Stakeholder(s)
        <strong className="bordered bordered-xs text-muted m-l-8">
          Total:&nbsp;
          <span className="text-info-brand count">
            {selectedIndividuals.length}
          </span>
        </strong>
      </ControlLabel>
      <div className="m-b-12">
        <div className="bulk-select m-b-12">
          <div className="flex flex-align-start flex-wrap">
            {filteredStakeholders &&
              selectedIndividuals.map((stakeholderId) => {
                const stakeholder = filteredStakeholders.find(
                  ({ id }) => id === stakeholderId
                );
                return (
                  <div
                    key={stakeholderId}
                    className="flex m-t-4 m-l-4 item-style"
                  >
                    {stakeholder
                      ? `${stakeholder.fullName} ${stakeholder.archived ? '(archived)' : ''}`
                      : ''}
                    <span
                      onClick={() => handleRemove(stakeholderId)}
                      className="btn btn-clear close-btn"
                    >
                      <CloseIcon />
                    </span>
                  </div>
                );
              })}
          </div>
          <Combobox
            entities={filteredStakeholders}
            onInputValueChange={onInputValueChange}
            onSelectedItemChange={onSelectedItemChange}
            isActive={isActive}
            getItemName={(item) => item.fullName}
            placeholder="Start Typing"
            controlId="org-stakeholder"
            customMenuItem={(comboboxProps) =>
              CustomSelectMenuItem(comboboxProps, isActive, isDisabled)
            }
          />
        </div>
      </div>
    </FormGroup>
  ) : null;
};

export default IndividualStakeholdersBulkSelect;
